import styled from 'styled-components';

export const Container = styled.div`
	min-height: 80vh;
	padding: 2rem;
	background-color: white;
	border-radius: 6px;
	box-shadow: 0 4px 8px 2px hsla(0, 0%, 0%, 0.1);
`;
